import { IMutations } from './mutations.types'
import { IFeedback, INotification, IApplication, ApplicationBudget } from '@/entities'

export const mutations: IMutations = {
  
  /** update the state with new list */
  updateFeedbackInfo(state: IFeedback, payload: any) {
    state.feedbackHeaders = payload;
  },

  /*** add feedback to the list */
  addFeedbackInfo(state: IFeedback, payload: any) {
    if(payload)
      state.feedbackHeaders.push(payload);
  },

  /** mark the thread as read */
  markFeedbackRead(state: IFeedback, payload: number) {
    if(payload){
      let header = state.feedbackHeaders.find(x => x.FeedbackHeaderId == payload);
      header.Count = 0;
    }      
  },

  /** mark the thread as resolved */
  setAsResolved(state: IFeedback, payload: number) {
    if(payload){
      let header = state.feedbackHeaders.find(x => x.FeedbackHeaderId == payload);
      header.Resolved = true;
    }      
  },

  /** mark the thread as resolved */
  reopen(state: IFeedback, payload: number) {
    if(payload){
      let header = state.feedbackHeaders.find(x => x.FeedbackHeaderId == payload);
      header.Resolved = false;
    }      
  }
}
